import { get } from 'utils';

export default function getTableData(
  { method = get, apiEndpoint = '', params = {} },
  callback = () => {}
) {
  const controller = new AbortController();

  method(
    { apiKey: apiEndpoint },
    { params, config: { signal: controller.signal } }
  )
    .then(res => callback(null, res))
    .catch(err => callback(err, {}));

  return controller;
}
